// Actions
export const SAVE_POLICY_RESPONSE = 'SAVE_POLICY_RESPONSE';
export const CLOSED_DIALOG = 'CLOSED_DIALOG';

// Initial State
export const commonInitialState = {
  policyAccepted: false
};

// Reducer
export function common(state, action) {
  if (!state) {
    state = commonInitialState;
  }
  switch (action.type) {
    case SAVE_POLICY_RESPONSE:
      return { ...state, policyAccepted: action.payload };
    case CLOSED_DIALOG:
      return { ...state, policyAccepted: true };
    default:
      return state;
  }
}

// Action Creators
export function updatePolicyStatus(payload) {
  return { type: SAVE_POLICY_RESPONSE, payload };
}

export function closedialog() {
  return { type: CLOSED_DIALOG };
}
